'use strict';

/*global app*/
/*global services*/
/*global nl2br*/
/*global normalizeInput*/
/*global createObjectCallBack*/

function SelectSevice() {
  this.modal = null;
  this.value = null;

  this.init();
}

SelectSevice.prototype = $.extend({}, {
  constructor: 'SelectSevice',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    this.modal.contentDOM().on('click', '.select-service__item', function () {
      _this.chooseValue($(this).data('id'));
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  chooseValue: function chooseValue(id) {
    var _this = this;

    _this.value = id;
    _this.modal.close();

    return _this;
  },

  close: function close(data) {
    var _this = this;

    if (data.callBack) {
      data.callBack(_this.value);
    }

    return _this;
  },

  createHtmlList: function createHtmlList(list) {
    var html = '';

    html += '<div>';

    $.each(list, function (key, item) {
      html += '<button data-id="' + item.id + '" class="btn btn-primary btn-lg full-width offset-bottom-5 select-service__item">' + item.abbr + '</button>';
    });

    html += '</div>';

    return html;
  },

  selectValue: function selectValue(data, callBack) {
    var _this = this;

    _this.value = null;

    data = normalizeInput(data);
    data.callBack = callBack;

    var content = data.content || '';

    if (data.asHtml && content) {
      content = '<p class="text-center">' + nl2br(content) + '</p>';
    }

    content += _this.createHtmlList(data.list);

    _this.modal.empty().open({
      title: data.title,
      saveBtnTitle: app.t('form.insert'),
      height: 'auto',
      width: 'md',
      closeCallBack: createObjectCallBack(_this, 'close', data),
      keyboardClose: false,
      content: content,
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-input');

    _this.registerCallbacks();

    return _this;
  }
});
